import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useContext } from 'react';
import { Context } from '../index';

const ForwardModal = observer(() => {
  const { chat } = useContext(Context);
  const [search, setSearch] = useState('');

  if (!chat.showForwardModal) return null;

  const filteredChats = chat.chats.filter(c => {
    if (!search) return true;
    const name = c.type === 'private' 
      ? (c.companion?.name || c.companion?.email || '')
      : (c.name || '');
    return name.toLowerCase().includes(search.toLowerCase());
  });

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'rgba(0,0,0,0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 10001
    }}>
      <div style={{
        background: 'white',
        borderRadius: '12px',
        width: '400px',
        maxHeight: '600px',
        display: 'flex',
        flexDirection: 'column'
      }}>
        <div style={{
          padding: '16px',
          borderBottom: '1px solid #eee',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          <h3 style={{ margin: 0, fontSize: '18px' }}>Переслать в чат</h3>
          <button
            onClick={() => chat.hideForwardModal()}
            style={{
              background: 'transparent',
              border: 'none',
              fontSize: '24px',
              cursor: 'pointer',
              color: '#999'
            }}
          >
            ×
          </button>
        </div>

        <div style={{ padding: '12px 16px' }}>
          <input
            type="text"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder="Поиск чата..."
            style={{
              width: '100%',
              padding: '8px 12px',
              borderRadius: '8px',
              border: '1px solid #ddd',
              outline: 'none'
            }}
          />
        </div>

        <div style={{
          flex: 1,
          overflowY: 'auto',
          padding: '0 8px 8px'
        }}>
          {filteredChats.map(c => {
            const name = c.type === 'private'
              ? (c.companion?.name || c.companion?.email || 'Чат')
              : (c.name || 'Группа');

            return (
              <div
                key={c.id}
                onClick={() => chat.forwardMessage(c.id)}
                style={{
                  padding: '12px',
                  cursor: 'pointer',
                  borderRadius: '8px',
                  transition: 'background 0.2s',
                  marginBottom: '4px'
                }}
                onMouseEnter={(e) => e.currentTarget.style.background = '#f5f5f5'}
                onMouseLeave={(e) => e.currentTarget.style.background = 'white'}
              >
                <div style={{ fontWeight: '500' }}>{name}</div>
                {c.lastMessage && (
                  <div style={{ fontSize: '12px', color: '#999', marginTop: '4px' }}>
                    {c.lastMessage.text?.substring(0, 50)}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
});

export default ForwardModal;